export default function AnimatedDrawingCards() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="0 0 832 1476"
      width="100%"
      height="100%"
      fill="none"
      preserveAspectRatio={'none'}
      className="-z-10 absolute inset-0 min-h-screen min-w-screen h-full w-full"
    >
      <defs>
        <style>
          {`
      .cls-1 {
        fill: #20145f;
      }

      .cls-2 {
        fill: #fff;
      }

      .cls-3 {
        fill: #99d9d9;
      }

      .cls-4 {
        fill: none;
      }

      .cls-5 {
        fill: #1d1a34;
      }

      .cls-6 {
        fill: #d51668;
      }

      .cls-7 {
        clipPath: url(#clippath);
      }`}
        </style>
        <clipPath id="clippath">
          <rect className="cls-4" width="832" height="1476" />
        </clipPath>
      </defs>
      <g>
        <g id="a">
          <g className="cls-7">
            <g>
              <rect className="cls-2" y="-.8" width="832" height="1476.8" />
              <path
                className="cls-1"
                d="M499.8-466.4l16.4,8.2-157.2,24.9c-55,9.9-109.8,18.1-164.4,29.3-24.6,5-61.7,11.1-84.2,19.4-8.5,3.1-12.3,11.4-17.9,17.7C12.9-277.7-57.2-173.3-124.1-72.6-166.3-9.1-208.8,55.8-243.9,124.8c-33.1,64.9-67.4,133.8-97.3,202.8-4.6,10.5-9.2,9.4-1,21.6,7,10.4,32.6,28.8,43.6,36.3,102.3,70,204.4,148.1,306.2,222.4l53,36.9c5.7,1.8,9-1.2,13.5-2.5,39.6-11,80.9-32.1,117.9-48.7,117.6-52.8,238.3-99.5,357.9-148.1,5.7-2.3,13.9-5.6,19.4-7.8,15-6.1,29.1-13.6,44.7-18.2,55.7,10,111,26.4,167.4,33.6,9.7,1.2,43.6,6,51.2,4.9,5-.7,20.4-8.9,26.1-11.6,39.5-19.3,80.4-36.9,120-57.3,50.6-26.1,100.8-55.7,153.9-79.7,14.3-6.5,29.7-10.7,42.2-19.2-.7-6.7-7-9.1-10.4-13.4-12.7-16.2-25.4-84-32.2-107.5-10-34.4-25.6-68.4-35.3-102.5-3.1-10.9-4.3-22.8-7.4-33.8-11.9-42.2-27-83.6-40.8-125.4-24.1-73-51.6-145.9-61.4-222.4-.9-2.5-2.3-4.8-4-6.9-1.4-1.6-8.2-7-10-8-13.9-8-31.7-11.6-46.2-17.6-10.8-4.5-20.9-11.3-31.5-16.2-34.7-16-70-30.2-103-49.5-33.1-19.4-65.6-43.5-100.2-62.7-6.8-3.8-17.9-10.1-25.6-10.3-16.6-.5-43,1.4-59.9,2.6-31.2,2.3-60.2,11.7-90.8,16.5-5.4.8-11.1,1.8-16.4.7h0Z"
              />
              <path
                className="cls-6"
                d="M343.8,1192.5c-8.4,9.2-23.5,26.6-40.6,39.8-2.2,1.7-12.9-1.2-16.7-.9l-34.8-2.5-93.8-11.7-120.4-13.5c-10.2-1.5-20.4-3.3-30.6-4.8-56.3-8.3-111.9-18.2-167.6-29.6-23.2-4.7-46.4-7.6-69.6-12.1-19.5-3.8-38.6-9.8-58.1-13.6-39.8-7.6-79.6-12.5-119.2-21.2-4.9-1.1-12.5-1.4-16.7-3-3.6-1.3,1.6-5.9,3.3-7.8,6.2-6.9,11.5-9,17.6-14.4,8.6-7.7,16.9-15.4,26.2-22.3,8.2-6.1,18.2-10.6,26.5-16.6,5.3-3.8,10.1-8.7,15.3-12.6,20.2-15.3,41.2-30,62.1-44.7,14.3-10.1,30.9-18.6,45.8-28,5.4-3.4,5.7-4.9,3.1-11-6.9-15.7-22.1-29.6-27.7-46.7-8-20.8-16.9-40.8-28.6-60v-2.2c1.2,0,2.3-.2,3.4-.2,22.2,1.9,45.2,9.5,67.5,12.2,14.3,1.7,28.5,1,42.8,1.4,12.8.4,23.5-.5,34.8,6.3,16.8,10.1,33.2,20.4,49.2,31.8,71,50.6,144.7,96.2,220,140.3,24,14.1,45.3,30.2,68.7,44.2,18.1,10.9,38,19.9,56.5,30.6,24.2,13.9,47.5,23.8,72.1,36.2,5.1,2.6,10,7.4,15.1,9.8,3.8,1.8,8.3,2.6,12,4.7.1,1.1-.3,1.9-.9,2.8-3.7,5.8-12,14.1-16.9,19.4h0Z"
              />
              <path
                className="cls-3"
                d="M1011.6,1593.6c-5.5-12.3-5.1-26.3-7.6-39.4-1.4-7.4-4.3-15.1-5.7-22.6-10.6-56.1-18.5-112.9-29-168.9-6.7-35.5-16.3-70.3-20.8-106.3-.3-2.4,1.1-5.1-.9-7.6l.2,2.9c-2.3,3.8-3.3-2.6-4.4-4.4-8.7-14.6-18.9-29.7-26.6-44.8-5.9-11.5-10.1-25.7-16.4-36.7-3.5-6.2-10.1-11.2-13.5-17.7-3-2.3-10.4,1.3-13.3,1.9-26,5-52.5,14.1-78,21.1-119.9,32.9-239.7,64.3-357,106.6-55,19.8-108.6,47.4-163,67.4-44.5,16.3-86.9,40.1-133.8,48.2-6.3,2.7-3.2,5.6-3.7,8.9-1.5,8.9-4.9,18.7-6.4,27.9-2,12.3-2.4,27.8-5.4,39.3-1.7,6.7-4.9,16.5-5.4,22.5-.6,8.1,4.7,15.9,10.3,21.6,14.6,14.8,35.7,29.8,51.5,44.3,40.7,37.4,77.8,77.9,114.2,119.6,6.6,7.5,14.2,14.3,20.6,22,11.1,13.2,19,28.6,25.8,44.4l1.2.7,27.9-5.5c5.5-.6,11.2-1,16.7-1.7,88.6-11.2,177.5-14.5,266.4-22.6,16-1.5,32.4-4.4,48.7-5.3,21.8-1.3,45.8-1.4,66.3-.9,39,1,77.9,3.6,116.7,4.1,3-.8,11.3-10.7,14.3-13.6,30-27.8,58.5-56.9,87.7-85.2,7.2-6.9,15.5-12.8,22-20.3h0Z"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
